import React, {useEffect, useState, useRef} from 'react';
import * as S from './GoSafeBanner.styles';
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";
import { getLoadedComponent } from '../../../../../shared/config/omni';
interface IBanner {
  bannerData: Array<{ img: string; link: string;}>
}

const GoSafeBanner: React.FC<IBanner> = ({ bannerData = [] }) => {
  if (!bannerData) return;
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
    reset,
  } = useCarousel(bannerData, 1, true);
  var timerId;
  const [activeBannerIndex, setActiveBannerIndex] = useState(0);
  const activeIndexForSetTimeout = useRef(activeBannerIndex);

  const incrementSlider = () => {
    let index = activeIndexForSetTimeout.current + 1;
    if (activeIndexForSetTimeout.current === bannerData.length - 1) index = 0;
    setActiveBannerIndex(index);
    clearInterval(timerId);
    increment();
  };

  const decrementSlider = () => {
    let index = activeIndexForSetTimeout.current - 1;
    if (activeIndexForSetTimeout.current == 0) index = bannerData.length - 1;
    setActiveBannerIndex(index);
    clearInterval(timerId);
    decrement();
  };

  useEffect(() => {
    activeIndexForSetTimeout.current = activeBannerIndex;
  }, [activeBannerIndex]);

  useEffect(() => {
    getLoadedComponent('GoSafeBanner')
  }, [])

  useEffect(() => {
    const bannerDataLength = bannerData.length;
    if (bannerDataLength && !timerId) {
      timerId = setInterval(() => {
        if (bannerDataLength) {
          if (activeIndexForSetTimeout.current < bannerDataLength - 1) {
            setActiveBannerIndex(activeIndexForSetTimeout.current + 1);
            increment();
          } else {
            setActiveBannerIndex(0);
            reset();
          }
        }
      }, 5000);
    }
    return () => clearInterval(timerId);
  }, [dataList]);

  const onClickHandlerForBanner = link => {
    if (!link) return;
    window.open(link, '_parent');
  };

  return (
    <>
      <S.HomeCaroMainImageWrap>
        {bannerData[activeBannerIndex] && (
          <S.HomeCaroBigImg src={bannerData[activeBannerIndex].img} alt="" onClick={() => onClickHandlerForBanner(bannerData[activeBannerIndex].link)} />
        ) || null}
      </S.HomeCaroMainImageWrap>
      {/* {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => {
            incrementSlider();
            onClickHandlerForBanner(`+${rightCursor}`);
          }}
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            onClickHandlerForBanner(`-${leftCursor}`);
            decrementSlider();
          }}
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null} */}
    </>
  );
};

export default GoSafeBanner;